export default {
      id: "i-empty-usage",
      viewBox: "0 0 99 77",
      url: __webpack_public_path__ + "img/sprite.svg#i-empty",
      toString: function () {
        return this.url;
      }
    }